var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 640,
    viewBox: "0 0 490 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20H113.263L140.737 48.125H349.263L376.737 20H450V132.5L422.526 161.094V413.75L450 470V620H376.737L349.263 591.875H140.737L113.263 620H40V470L67.4737 413.75V161.094L40 132.5V20Z",
    fill: "#221A2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20H113.263L140.737 48.125H349.263L376.737 20H450V132.5L422.526 161.094V413.75L450 470V620H376.737L349.263 591.875H140.737L113.263 620H40V470L67.4737 413.75V161.094L40 132.5V20Z",
    fill: "#221A2B",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80L110 30H380L410 0H490V120L460 150.5V420L490 480V640H410L380 610H110L80 640H0V480L30 420V150.5L0 120V0Z",
    fill: "#221A2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80L110 30H380L410 0H490V120L460 150.5V420L490 480V640H410L380 610H110L80 640H0V480L30 420V150.5L0 120V0Z",
    fill: "#221A2B",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 69H92.3895L121.411 91.1719H367.589L396.611 69H474V157.688L444.979 180.229V379.406L474 423.75V542H396.611L367.589 519.828H121.411L92.3895 542H15V423.75L44.0211 379.406V180.229L15 157.688V69Z",
    fill: "#221A2B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 69H92.3895L121.411 91.1719H367.589L396.611 69H474V157.688L444.979 180.229V379.406L474 423.75V542H396.611L367.589 519.828H121.411L92.3895 542H15V423.75L44.0211 379.406V180.229L15 157.688V69Z",
    fill: "#221A2B",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBgMobile);
export default __webpack_public_path__ + "static/media/contactBG_mobile.3a923618edbb974d91ff98ba44d0722a.svg";
export { ForwardRef as ReactComponent };